<div class="flex flex-col flex-1 gap-2">
  <snt-tag [name]=""></snt-tag>
</div>
